import { render, staticRenderFns } from "./rosterErroe.vue?vue&type=template&id=0a9fd434&scoped=true&"
import script from "./rosterErroe.vue?vue&type=script&lang=js&"
export * from "./rosterErroe.vue?vue&type=script&lang=js&"
import style0 from "./rosterErroe.vue?vue&type=style&index=0&id=0a9fd434&prod&scoped=true&lang=css&"
import style1 from "./rosterErroe.vue?vue&type=style&index=1&id=0a9fd434&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9fd434",
  null
  
)

export default component.exports